/* GoBrands - brand size charts.
 * Adds a "Size chart" button on the Size label row of shoe product pages and opens the chart of the product's own brand (its vendor). Charts are copied from each brand's official size page (see `src`). A brand with no chart here gets a how-to-measure guide and a WhatsApp link instead, never a guess.
 * TO ADD OR FIX A BRAND: add an entry to CHARTS and one line to BRANDS.
 *   t(label, columns, rows, note)  one table; rows are 'a|b|c' strings
 *   sys (optional)  the size system the brand is sold in ('US', 'UK'): that column is shown first with a green header */
(function () {
  'use strict';

  function t(label, cols, rows, note) {
    return { label: label, cols: cols, rows: rows.map(function (r) { return r.split('|'); }), note: note || '' };
  }

  /* Nike prints men's sizes; women's US size is men's + 1.5 (Nike's own rule) */
  function nikeAdult() {
    var m = [
      '3.5|3|35.5|22.5', '4|3.5|36|23', '4.5|4|36.5|23.5', '5|4.5|37.5|23.5', '5.5|5|38|24', '6|5.5|38.5|24',
      '6.5|6|39|24.5', '7|6|40|25', '7.5|6.5|40.5|25.5', '8|7|41|26', '8.5|7.5|42|26.5', '9|8|42.5|27',
      '9.5|8.5|43|27.5', '10|9|44|28', '10.5|9.5|44.5|28.5', '11|10|45|29', '11.5|10.5|45.5|29.5', '12|11|46|30',
      '12.5|11.5|47|30.5', '13|12|47.5|31', '13.5|12.5|48|31.5', '14|13|48.5|32', '15|14|49.5|33', '16|15|50.5|34'
    ].map(function (r) {
      var p = r.split('|');
      return p[2] + '|' + p[1] + '|' + p[0] + '|' + (parseFloat(p[0]) + 1.5) + '|' + p[3];
    });
    return t('Men & Women', ['EU', 'UK', 'US Men', 'US Women', 'CM / JP'], m,
      'Nike\'s CM/JP is the size printed on the box, not your foot length. Women\'s US size is men\'s + 1.5.');
  }

  var CHARTS = {
    adidas: {
      name: 'adidas',
      sys: 'UK',
      src: 'https://www.adidas.com/kw/en/size-chart-men-shoes.html',
      tip: 'In between sizes? For a tight fit go one size down, for a loose fit go one size up.',
      tables: {
        adult: t('Men & Women', ['EU', 'UK', 'US Men', 'US Women', 'Foot (cm)'], [
          '36|3.5|4|5|22.1', '36 2/3|4|4.5|5.5|22.5', '37 1/3|4.5|5|6|22.9', '38|5|5.5|6.5|23.3', '38 2/3|5.5|6|7|23.8',
          '39 1/3|6|6.5|7.5|24.2', '40|6.5|7|8|24.6', '40 2/3|7|7.5|8.5|25.0', '41 1/3|7.5|8|9|25.5', '42|8|8.5|9.5|25.9',
          '42 2/3|8.5|9|10|26.3', '43 1/3|9|9.5|10.5|26.7', '44|9.5|10|11|27.1', '44 2/3|10|10.5|11.5|27.6',
          '45 1/3|10.5|11|12|28.0', '46|11|11.5|12.5|28.4', '46 2/3|11.5|12|13|28.8', '47 1/3|12|12.5|13.5|29.3',
          '48|12.5|13|14|29.7', '48 2/3|13|13.5|14.5|30.1', '49 1/3|13.5|14|15|30.5', '50|14|14.5|15.5|31.0',
          '50 2/3|14.5|15|--|31.4', '51 1/3|15|16|--|31.8', '52 2/3|16|17|--|32.6', '53 1/3|17|18|--|33.5'
        ]),
        kids: [
          t('Babies & toddlers (0-3 yrs)', ['EU', 'UK', 'US', 'Foot (cm)'], [
            '16|0k|1k|8.1', '17|1k|2k|9.0', '18|2k|3k|9.8', '19|3k|4k|10.6', '20|4k|5k|11.5', '21|5k|5.5k|12.3', '22|5.5k|6k|12.8',
            '23|6k|6.5k|13.2', '23.5|6.5k|7k|13.6', '24|7k|7.5k|14.0', '25|7.5k|8k|14.5', '25.5|8k|8.5k|14.9', '26|8.5k|9k|15.3',
            '26.5|9k|9.5k|15.7', '27|9.5k|10k|16.1'
          ]),
          t('Children (4-7 yrs)', ['EU', 'UK', 'US', 'Foot (cm)'], [
            '28|10k|10.5k|16.6', '28.5|10.5k|11k|17.0', '29|11k|11.5k|17.4', '30|11.5k|12k|17.8', '30.5|12k|12.5k|18.3',
            '31|12.5k|13k|18.7', '31.5|13k|13.5k|19.1', '32|13.5k|1|19.5', '33|1|1.5|20.0', '33.5|1.5|2|20.4', '34|2|2.5|20.8', '35|2.5|3|21.2'
          ]),
          t('Youth & teens (8-16 yrs)', ['EU', 'UK', 'US', 'Foot (cm)'], [
            '35.5|3|3.5|21.6', '36|3.5|4|22.1', '36 2/3|4|4.5|22.5', '37 1/3|4.5|5|22.9', '38|5|5.5|23.3', '38 2/3|5.5|6|23.8',
            '39 1/3|6|6.5|24.2', '40|6.5|7|24.6', '40 2/3|7|7.5|25.0'
          ])
        ]
      }
    },
    nike: {
      name: 'Nike',
      sys: 'US',
      src: 'https://www.nike.com/size-fit/mens-footwear',
      tip: 'Between two sizes? Nike suggests the larger one.',
      tables: {
        adult: nikeAdult(),
        kids: [
          t('Babies & toddlers (1C-10C)', ['EU', 'UK', 'US Kids', 'CM / JP'], [
            '16|0.5|1C|7', '17|1.5|2C|8', '18.5|2.5|3C|9', '19.5|3.5|4C|10', '21|4.5|5C|11', '22|5.5|6C|12', '23.5|6.5|7C|13',
            '25|7.5|8C|14', '26|8.5|9C|15', '27|9.5|10C|16'
          ]),
          t('Little kids (10.5C-3Y)', ['EU', 'UK', 'US Kids', 'CM / JP'], [
            '27.5|10|10.5C|16.5', '28|10.5|11C|17', '28.5|11|11.5C|17.5', '29.5|11.5|12C|18', '30|12|12.5C|18.5', '31|12.5|13C|19',
            '31.5|13|13.5C|19.5', '32|13.5|1Y|20', '33|1|1.5Y|20.5', '33.5|1.5|2Y|21', '34|2|2.5Y|21.5', '35|2.5|3Y|22'
          ]),
          t('Big kids (3.5Y-7Y)', ['EU', 'UK', 'US Kids', 'CM / JP'], [
            '35.5|3|3.5Y|22.5', '36|3.5|4Y|23', '36.5|4|4.5Y|23.5', '37.5|4.5|5Y|23.5', '38|5|5.5Y|24', '38.5|5.5|6Y|24',
            '39|6|6.5Y|24.5', '40|6|7Y|25'
          ])
        ]
      }
    },
    puma: {
      name: 'PUMA',
      sys: 'UK',
      src: 'https://eu.puma.com/ch/en/help/size-guide',
      tip: 'PUMA sizes differ slightly between men and women, so use the matching table.',
      tables: {
        men: t('Men', ['EU', 'UK', 'US'], [
          '38|5|6', '38.5|5.5|6.5', '39|6|7', '40|6.5|7.5', '41|7|8.5', '42|8|9', '42.5|8.5|9.5', '43|9|10', '44|9.5|10.5',
          '44.5|10|11', '45|10.5|11.5', '46|11|12', '46.5|11.5|12.5', '47|12|13', '48.5|13|14', '49.5|14|15', '51|15|16'
        ]),
        women: t('Women', ['EU', 'UK', 'US'], [
          '35.5|3|5.5', '36|3.5|6', '37|4|7', '37.5|4.5|7.5', '38|5|8', '38.5|5.5|8.5', '39|6|9', '40|6|9.5', '41|7.5|10', '42|8|10.5', '42.5|8.5|11'
        ]),
        kids: [
          t('Kids', ['EU', 'UK', 'US'], [
            '27|9|10', '27.5|9.5|10.5', '28|10|11', '28.5|10.5|11.5', '29|11|12', '30|11.5|12.5', '31|12|13', '31.5|12.5|13.5',
            '32|13|1', '32.5|13.5|1.5', '33|1|2', '34|1.5|2.5', '34.5|2|3', '35|2.5|3.5', '35.5|3|4', '36|3.5|4.5', '37|4|5',
            '37.5|4.5|5.5', '38|5|6', '38.5|5.5|6.5', '39|6|7'
          ]),
          t('Babies & toddlers', ['EU', 'UK', 'US'], [
            '18|2|3', '19|3|4', '20|4|5', '21|4.5|5.5', '22|5|6', '23|6|7', '24|7|8', '25|8|9', '26|8.5|9.5'
          ])
        ]
      }
    },
    skechers: {
      name: 'Skechers',
      sys: 'US',
      src: 'https://www.skechers.com/size-chart/',
      tip: 'Skechers performance running and walking styles can fit differently. Check the product notes.',
      tables: {
        women: t('Women', ['EU', 'UK', 'US'], [
          '35|2|5', '35.5|2.5|5.5', '36|3|6', '36.5|3.5|6.5', '37|4|7', '37.5|4.5|7.5', '38|5|8', '38.5|5.5|8.5', '39|6|9',
          '39.5|6.5|9.5', '40|7|10', '40.5|7.5|10.5', '41|8|11', '42|9|12', '43|10|13'
        ]),
        men: t('Men', ['EU', 'UK', 'US'], [
          '39|5.5|6.5', '39.5|6|7', '40|6.5|7.5', '41|7|8', '41.5|7.5|8.5', '42|8|9', '42.5|8.5|9.5', '43|9|10', '44|9.5|10.5',
          '45|10|11', '45.5|10.5|11.5', '46|11|12', '47|11.5|12.5', '47.5|12|13', '48|12.5|13.5', '48.5|13|14', '49.5|14|15', '50.5|15|16'
        ]),
        kids: [
          t('Kids', ['EU', 'UK', 'US'], [
            '27|9.5|10.5', '27.5|10|11', '28|10.5|11.5', '28.5|11|12', '29|11.5|12.5', '30|12|13', '31|12.5|13.5', '32|13|1',
            '33|13.5|1.5', '33.5|1|2', '34|1.5|2.5', '35|2|3', '35.5|2.5|3.5', '36|3|4', '36.5|3.5|4.5', '37|4|5', '37.5|4.5|5.5',
            '38|5|6', '39|5.5|6.5', '40|6|7'
          ]),
          t('Toddlers', ['EU', 'UK', 'US'], [
            '16|0|1', '17|1|2', '18.5|2|3', '19.5|3|4', '20.5|4|5', '21|4.5|5.5', '21.5|5|6', '22|5.5|6.5', '22.5|6|7', '23|6.5|7.5',
            '24|7|8', '25|7.5|8.5', '25.5|8|9', '26|8.5|9.5', '26.5|9|10'
          ])
        ]
      }
    },
    ua: {
      name: 'Under Armour',
      sys: 'US',
      src: 'https://www.underarmour.co.uk/en-gb/t/size-guide/mens-footwear/',
      tip: 'Between two sizes? Under Armour recommends sizing up.',
      tables: {
        men: t('Men', ['EU', 'UK', 'US Men', 'Foot (cm)'], [
          '40|6|7|25', '40.5|6.5|7.5|25.5', '41|7|8|26', '42|7.5|8.5|26.5', '42.5|8|9|27', '43|8.5|9.5|27.5', '44|9|10|28',
          '44.5|9.5|10.5|28.5', '45|10|11|29', '45.5|10.5|11.5|29.5', '46|11|12|30', '47|11.5|12.5|30.5', '47.5|12|13|31',
          '48|12.5|13.5|31.5', '48.5|13|14|32'
        ])
      }
    }
  };

  /* vendor (lower case) -> chart key */
  var BRANDS = {
    'adidas': 'adidas', 'adidas originals': 'adidas',
    'nike': 'nike', 'jordan': 'nike',
    'puma': 'puma',
    'skechers': 'skechers',
    'ua': 'ua', 'under armour': 'ua'
  };

  var WA = '9613900246';

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function meta() {
    var m = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) || null;
    if (m) return { vendor: m.vendor || '', type: m.type || '' };
    return null;
  }

  function pickGroups(chart, title, sizes) {
    var groups = [];
    var T = chart.tables;
    if (T.adult) groups.push({ label: 'Men & Women', tables: [T.adult], key: 'adult' });
    if (T.men) groups.push({ label: 'Men', tables: [T.men], key: 'men' });
    if (T.women) groups.push({ label: 'Women', tables: [T.women], key: 'women' });
    if (T.kids) groups.push({ label: 'Kids', tables: T.kids, key: 'kids' });

    var s = (title || '').toLowerCase();
    var nums = sizes.map(function (v) { return parseFloat(v); }).filter(function (n) { return !isNaN(n); });
    var top = nums.length ? Math.max.apply(null, nums) : 0;
    var kidsWord = /\b(kids?|junior|youth|infant|toddler|boys?|girls?|baby|child|children)\b/.test(s);
    var want = 'men';
    if (top && top <= 35 || kidsWord || sizes.some(function (v) { return /[CYK]$/i.test(v); })) want = 'kids';
    else if (/\bwomen|womens|women's|ladies|\bwmns?\b/.test(s) || (top && top <= 39.5)) want = 'women';
    var idx = 0;
    groups.forEach(function (g, i) {
      if (g.key === want || (g.key === 'adult' && want !== 'kids')) idx = i;
    });
    return { groups: groups, def: idx };
  }

  /* some feeds drop the slash in thirds: "41 13" is 41 1/3, "42 23" is 42 2/3 */
  function normSize(v) {
    return String(v).toLowerCase().replace(/\s+/g, ' ').trim().replace(/^(\d+) 13$/, '$1 1/3').replace(/^(\d+) 23$/, '$1 2/3');
  }

  /* index of the column in the brand's own size system, -1 when the brand has none */
  function sysIndex(tbl, sys) {
    if (!sys) return -1;
    for (var i = 0; i < tbl.cols.length; i++) {
      if (tbl.cols[i].indexOf(sys) === 0) return i;
    }
    return -1;
  }

  /* a row is green when one of the product's sizes is its EU size or its size in the brand's own system */
  function tableHTML(tbl, sizes, sys) {
    var have = {};
    sizes.forEach(function (v) { have[normSize(v)] = 1; });
    var own = sysIndex(tbl, sys);
    var order = tbl.cols.map(function (c, i) { return i; });
    if (own > 0) { order.splice(own, 1); order.unshift(own); }
    var h = '<div class="gb-sc__tw"><table class="gb-sc__t"><thead><tr>';
    order.forEach(function (ci, pos) {
      h += '<th scope="col"' + (own >= 0 && pos === 0 ? ' class="is-sys"' : '') + '>' + esc(tbl.cols[ci]) + '</th>';
    });
    h += '</tr></thead><tbody>';
    tbl.rows.forEach(function (r) {
      var on = have[normSize(r[0])] || (own >= 0 && have[normSize(r[own])]) ? ' class="is-yours"' : '';
      h += '<tr' + on + '>';
      order.forEach(function (ci, pos) { h += pos === 0 ? '<th scope="row">' + esc(r[ci]) + '</th>' : '<td>' + esc(r[ci]) + '</td>'; });
      h += '</tr>';
    });
    h += '</tbody></table></div>';
    if (tbl.note) h += '<p class="gb-sc__note">' + esc(tbl.note) + '</p>';
    return h;
  }

  var MEASURE =
    '<div class="gb-sc__how"><h3>How to measure your foot</h3><ol>' +
    '<li>Stand on a sheet of paper with your heel against a wall.</li>' +
    '<li>Mark the tip of your longest toe and measure from the wall to the mark.</li>' +
    '<li>Do both feet, use the longer one, and measure at the end of the day.</li></ol></div>';

  function build(vendorName, chart, title, sizes, url) {
    var dlg = document.createElement('dialog');
    dlg.className = 'gb-sc';
    dlg.setAttribute('aria-labelledby', 'gb-sc-title');

    var body = '';
    if (chart) {
      var g = pickGroups(chart, title, sizes);
      if (chart.sys) body += '<p class="gb-sc__sys">' + esc(chart.name) + ' sizes are listed in <strong>' + esc(chart.sys) + '</strong> first. The sizes this product comes in are highlighted in green.</p>';
      body += '<div class="gb-sc__tabs" role="tablist">';
      g.groups.forEach(function (x, i) {
        body += '<button type="button" role="tab" class="gb-sc__tab" data-i="' + i + '" aria-selected="' + (i === g.def) + '">' + esc(x.label) + '</button>';
      });
      body += '</div>';
      g.groups.forEach(function (x, i) {
        body += '<div class="gb-sc__panel" data-i="' + i + '"' + (i === g.def ? '' : ' hidden') + '>';
        x.tables.forEach(function (tb) {
          if (x.tables.length > 1) body += '<h3 class="gb-sc__sub">' + esc(tb.label) + '</h3>';
          body += tableHTML(tb, sizes, chart.sys);
        });
        body += '</div>';
      });
      if (chart.tip) body += '<p class="gb-sc__tip">' + esc(chart.tip) + '</p>';
      body += MEASURE;
      body += '<p class="gb-sc__src">Source: <a href="' + esc(chart.src) + '" target="_blank" rel="noopener">' + esc(chart.name) + ' official size chart</a></p>';
    } else {
      body += '<p class="gb-sc__lead">We don\'t have a printed size chart for ' + esc(vendorName || 'this brand') + ' yet. Measure your foot below and message us, and we\'ll tell you the right size.</p>';
      body += MEASURE;
      var msg = encodeURIComponent('Hi, I need help choosing a size for: ' + title + ' - ' + location.origin + url);
      body += '<a class="gb-sc__wa" href="https://wa.me/' + WA + '?text=' + msg + '" target="_blank" rel="noopener">Ask us about your size on WhatsApp</a>';
    }

    dlg.innerHTML =
      '<div class="gb-sc__in"><header class="gb-sc__hd"><h2 id="gb-sc-title">' + esc((chart ? chart.name : vendorName || 'Size') + ' size chart') + '</h2>' +
      '<button type="button" class="gb-sc__x" aria-label="Close size chart"><svg viewBox="0 0 12 12" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M2 2l8 8M10 2l-8 8"/></svg></button></header>' +
      '<div class="gb-sc__bd">' + body + '</div></div>';

    dlg.querySelector('.gb-sc__x').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('gb-sc-open'); });
    dlg.querySelectorAll('.gb-sc__tab').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = b.getAttribute('data-i');
        dlg.querySelectorAll('.gb-sc__tab').forEach(function (x) { x.setAttribute('aria-selected', String(x === b)); });
        dlg.querySelectorAll('.gb-sc__panel').forEach(function (p) { p.hidden = p.getAttribute('data-i') !== i; });
      });
    });
    document.body.appendChild(dlg);
    return dlg;
  }

  function sizeInputs() {
    var out = [];
    document.querySelectorAll('product-info input[type="radio"], .product-form__input input[type="radio"]').forEach(function (i) {
      if (/size/i.test(i.name || '')) out.push(i);
    });
    return out;
  }

  function mount() {
    if (document.querySelector('.gb-sc-btn')) return true;
    var m = meta();
    var info = document.querySelector('product-info');
    if (!m || !info) return false;
    if (!/shoes?|footwear/i.test(m.type)) return true;

    var inputs = sizeInputs();
    if (!inputs.length) return true;
    var sizes = inputs.map(function (i) { return i.value; });

    /* the Size label row is the legend of the fieldset that holds the size chips */
    var fs = inputs[0].closest('fieldset');
    var picker = info.querySelector('variant-selects, variant-radios');
    if (!fs && !picker) return false;

    var key = BRANDS[String(m.vendor).toLowerCase().trim()];
    var chart = key ? CHARTS[key] : null;
    var h1 = document.querySelector('.product__title, h1');
    var title = h1 ? h1.textContent.trim() : document.title;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gb-sc-btn' + (fs ? ' gb-sc-btn--inline' : '');
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8.5l12.5-5 5 12.5-12.5 5z"/><path d="M7.5 10.2l1.6 4M10.4 9l1.2 3M13.3 7.8l1.6 4"/></svg><span>Size chart</span>';
    if (fs) fs.appendChild(btn);
    else picker.insertAdjacentElement('afterend', btn);

    var old = document.querySelector('dialog.gb-sc');
    if (old) old.remove();
    var dlg;
    btn.addEventListener('click', function () {
      if (!dlg) dlg = build(m.vendor, chart, title, sizes, location.pathname);
      document.documentElement.classList.add('gb-sc-open');
      dlg.showModal();
    });
    return true;
  }

  /* Dawn swaps parts of the product block when a size is picked; put the button back if it goes */
  function keepAlive() {
    var info = document.querySelector('product-info');
    if (!info) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        if (!document.querySelector('.gb-sc-btn')) mount();
      });
    }).observe(info, { childList: true, subtree: true });
  }

  function boot() {
    var n = 0;
    (function tick() {
      if (mount()) { keepAlive(); return; }
      if (++n > 40) return;
      setTimeout(tick, 250);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
